import React from 'react';
import logoSrc from 'src/images/logo.png';
import './header.css';

export default class Header extends React.Component {
  render() {
    return (
      <header className="page-header">
        <a className="page-header-logo" href="/">
          <img src={logoSrc} className="page-header-logo" alt="Playerbase" />
        </a>
        <div className="page-header-nav" />
        <a className="button page-header-login" href="https://app.playerbase.io/">
          Login
        </a>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header.js